import { ValueGetterParams } from "ag-grid-community";
import { createCommonUtilsApi } from "../../api-helpers/CommonUtilsApiHelper";
import Lookups from "../../constants/Lookups";
import { Lookup } from "common-util-experience-client";

const commonUtilApi = createCommonUtilsApi();

const lookupCache = new Map<string, string>();

async function loadLookups(lookupType: string, callback?: () => void): Promise<void> {
    try {
        const lookupsResponse = await commonUtilApi.lookupControllerFindAll(lookupType);
        lookupsResponse.data.forEach((lookup: Lookup) => lookupCache.set(lookup.id, lookup.name));
        callback?.();
    } catch (error) {
        console.error(error);
    }
}

export function cacheAllLookups(): void {
    const lookupTypes = Object.keys(Lookups);
    lookupTypes.forEach((lookupType) => {
        loadLookups((Lookups as any)[lookupType] as string);
    });
}

export const LookupCellValueGetter = (lookupType: string, params: ValueGetterParams) => {

    const lookupId = params.data[params.colDef.field!];
    if (lookupCache.has(lookupId)) {
        return lookupCache.get(lookupId);
    }

    loadLookups(lookupType, () => {
        params.api.refreshCells({
            rowNodes: [params.node!],
            columns: [params.column]
        });
    });
    
    return "-";
};
